import ClientUtils from './utils';

let baseUrl = '/auth/rest';

export default {
    getUserProfile: (callback, failureCallback) => {
        const url = `${baseUrl}/profile`;

        return ClientUtils.makeGetRequest(url, callback, {}, failureCallback, null, { 'Cache-Control': 'no-cache' });
    },
};
